export enum PaymentStatus {
    DECLINED = 'declined'
}

export enum CreditCardType {
    MASTER_CARD = 'MASTERCARD',
    VISA = 'VISA',
    AMEX = 'AMEX',
    DISCOVER = 'DISCOVER',
    AMERICANEXPRESS = 'AMERICANEXPRESS'
}

export enum ParamType {
    encoded = 'encodedParam',
    path = 'path',
    query = 'query',
    any = 'any'
}

export enum PlanGroup {
    UNLIMITED = 'Unlimited'
}

export enum NotificationCardType {
    SUCCESS = 'success',
    WARNING = 'warning',
    WARNING_REVERSAL = 'warningReversal',
    PAYMENT_FAILURE = 'paymentFailure',
    INFO = 'info'
}

export enum NowSimActivationStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}

export const MAX_ADD_LINE_COUNT: number = 5;

export const ESIM_DOWNLOAD_RECHECK_INTERVAL: number = 4000; 
export const ESIM_DOWNLOAD_RECHECK_TOTAL_ATTEMPTS: number = 5;

export enum ReturnDeviceOptionType {
    CHAT = 'chat',
    STORE = 'store'
}

export enum LOS {
    NOW_MOBILE = 'Now Mobile'
}

export enum NiFiServiceData {
    ACTION_ID = 'NOW_MOBILE_VIEW_LINES_AND_DATA_USAGE',
    INTERACTION_TYPE = 'BILLING_PAYMENTS',
    CHANNEL = 'MY_ACCOUNT_WEB',
    STATUS = 'SUCCESS'
}
